var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
import styled from 'styled-components';
export var Alert = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\nborder-radius: 5px;\npadding-right: 16px;\npadding: 0px 16px;\nmargin-bottom: 10px;\nmargin-left: ", ";\nposition: relative;\nbackground-color: #F9F9F9;\n"])), function (props) {
  return props.isMobile && '15px';
});
export var AlertIcon = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\nwidth: 64px;\nheight: 64px;\nposition: absolute;\nleft: -20px;\ndisplay: flex;\njustify-content: center;\nalign-items: center;\n"])));
export var AlertBoxChat = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\nborder-radius: 8px;\npadding: 16px;\nposition: relative;\nbackground-color: #F9F9F9;\n"])));
export var AlertIconChat = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\nwidth: 58px;\nheight: 58px;\nmargin-right: 16px;\n"])));